module.exports = __webpack_public_path__ + "img/completedTab.3d4e7a04.svg";